import { render } from "./ViolationForm.vue?vue&type=template&id=ecd3cc5e"
import script from "./ViolationForm.vue?vue&type=script&lang=js"
export * from "./ViolationForm.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/amatra-frontend-dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__